import React, { Component } from 'react';


import '../css/AdmHeader.css';

class AdmHeader extends Component {
  constructor() {
    super();
    this.state = {};
  }

  logout(){
    localStorage.removeItem("AUTH-X-TOKEN");
  }

  componentWillMount() {
    
  }

  render() {
    return (
        <div id="admHeader">
            <div id="admHeader-leftbox">
                Administrativo
            </div>
            <div id="admHeader-rightbox">
                <a href="/" onClick={this.logout.bind(this)}> <i className="fas fa-sign-out-alt"></i></a>
            </div>
        </div>
    );
  }
}

export default AdmHeader;



// WEBPACK FOOTER //
// ./src/adm/componentes/AdmHeader.js